import { GetBoardPostQuery } from '@/types/bff/gql-schema';
import { BoardPostDetailResponse } from '@/types/community';

import { useGetBoardPostQuery } from './community.gql.impl';

const useGetBoardPostByPostDetail = (boardPostPid: string) => {
  const { data, isLoading, refetch } = useGetBoardPostQuery(
    {
      boardPostPid,
    },
    {
      enabled: !!boardPostPid,
      refetchOnWindowFocus: true,
      select: parseBoardPostDetail,
    },
  );
  return { data, isLoading, refetch };
};

export default useGetBoardPostByPostDetail;

const parseBoardPostDetail = ({
  boardPost: {
    boardPostPid,
    boardCategoryId,
    title,
    content,
    likeCount,
    boardCommentCount,
    createdAt,
    isLikedByMe,
    isMine,
    blinded,
    boardPostAttachments,
    communityUser,
    boardCategory,
    boardComments,
  },
}: GetBoardPostQuery): BoardPostDetailResponse => {
  return {
    boardPostPid,
    boardCategoryId,
    title,
    content,
    likeCount,
    boardCommentCount,
    createdAt,
    isLikedByMe,
    isMine,
    blinded,
    boardPostAttachments,
    communityUser,
    boardCategory,
    boardComments,
  };
};
